import React from "react";
import ShieldRight from "../../assets/images/shield-check_right.png";
import Slider from "./components/Slider";
export default function ReviewsSection() {
  return (
    <div className="">
      <section className="container mx-auto mb-0 pb-0 md:mb-[111px] md:pb-[10px] 2xl:pb-[48px]">
        <div className="mb-[40px] flex flex-col items-center md:mb-[45px] 2xl:mb-[145px]">
          <h1 className="mb-[18px] text-center font-manrope text-[20px] font-extrabold leading-[28px] text-[#333333] md:mb-[14px] md:text-[26px] md:font-[800] md:leading-[36px] 2xl:mb-[20px] 2xl:text-[34px] 2xl:leading-[46px]">
            Trusted by Millions <br className="inline-block md:hidden" /> Around
            the Globe
          </h1>

          <p className="w-fit max-w-[312.24px] text-pretty text-center font-manrope text-[13px] font-semibold leading-[18px] text-[#666A7C] sm:max-w-fit md:text-[15px] md:font-[600] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]">
            There are the stories of our customers who have joined us with great
            pleasure when using this crazy feature.
          </p>
        </div>

        <Slider />
      </section>
      <img
        src={ShieldRight}
        alt="shield img"
        className="absolute right-0 z-50 hidden md:top-0 md:block md:h-[266.28px] 2xl:top-[6%] 2xl:h-auto 2xl:w-[200px]"
      />
    </div>
  );
}
